import React, { useState, useEffect } from "react";
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import { CANVAS_WIDTH, CANVAS_HEIGHT } from "./escapeRoomEditorConstants";
import { ElementRenderer } from "./escapeRoomElementRenderer";
import { ensureTextEffectStylesInjected } from "./textEffectStyles";

const THUMB_WIDTH = 128;
const THUMB_HEIGHT = 72;

function PagePreviewThumbnail({ elements, registrationDesign, isRegistration, backgroundColor, backgroundImageUrl, backgroundImageOpacity, quizzes = [], disableAudioPreview = true }) {
	const scale = THUMB_WIDTH / CANVAS_WIDTH;
	const noop = () => {};
	const [hintModalText, setHintModalText] = useState(null);
	useEffect(() => {
		ensureTextEffectStylesInjected();
	}, []);
	if (isRegistration) {
		return (
			<div
				className="er-static-preview"
				style={{
					width: THUMB_WIDTH,
					height: THUMB_HEIGHT,
					overflow: "hidden",
					borderRadius: 4,
					boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
					position: "relative",
					backgroundColor: registrationDesign?.backgroundColor || "#fff",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						gap: 2,
						padding: "6px 12px",
						background: "rgba(255,255,255,0.95)",
						borderRadius: 6,
						boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
						border: "1px solid rgba(0,0,0,0.04)",
					}}
				>
					<span
						style={{
							fontSize: 10,
							fontWeight: 700,
							color: "#1a1a1a",
							letterSpacing: "0.12em",
							textTransform: "uppercase",
						}}
					>
						Registro
					</span>
				</div>
			</div>
		);
	}
	return (
		<div
			className="er-static-preview"
			style={{
				width: THUMB_WIDTH,
				height: THUMB_HEIGHT,
				overflow: "hidden",
				backgroundColor: backgroundColor || "#fff",
				borderRadius: 4,
				boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
				position: "relative",
			}}
		>
			{backgroundImageUrl && (
				<div
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundImage: `url(${backgroundImageUrl})`,
						backgroundSize: "cover",
						backgroundPosition: "center",
						opacity: backgroundImageOpacity != null ? backgroundImageOpacity / 100 : 1,
						pointerEvents: "none",
					}}
				/>
			)}
			<div
				style={{
					width: CANVAS_WIDTH,
					height: CANVAS_HEIGHT,
					transform: `scale(${scale})`,
					transformOrigin: "0 0",
					position: "relative",
					zIndex: 1,
					pointerEvents: "none",
				}}
				onClick={(e) => {
					const hintEl = e.target.closest("[data-hint-preview]");
					if (hintEl && hintEl.dataset.hintText) {
						e.stopPropagation();
						setHintModalText(hintEl.dataset.hintText);
					}
				}}
			>
				{(elements || []).map((el, elIdx) => (
					<ElementRenderer
						key={`${el.elementId || "el"}_${elIdx}`}
						element={el}
						selected={false}
						preview
						disableAudioPreview={disableAudioPreview}
						onSelect={noop}
						onUpdate={noop}
						onDragStart={noop}
						onResizeStart={noop}
						registrationDesign={undefined}
						quizData={el.type === "quiz" ? quizzes.find((q) => String(q?._id) === String(el.content?.quizId || "")) : undefined}
						onButtonAction={noop}
						onQuizHintUsed={noop}
						onHintPreviewClick={(text) => setHintModalText(text)}
					/>
				))}
			</div>
			{hintModalText && (
				<Dialog open onClose={() => setHintModalText(null)} style={{ zIndex: 9999 }}>
					<DialogTitle>Pista</DialogTitle>
					<DialogContent><div style={{ whiteSpace: "pre-wrap" }}>{hintModalText}</div></DialogContent>
					<DialogActions>
						<Button onClick={() => setHintModalText(null)} variant="contained" color="primary">Cerrar</Button>
					</DialogActions>
				</Dialog>
			)}
		</div>
	);
}

export { THUMB_WIDTH, THUMB_HEIGHT, PagePreviewThumbnail };
